/*
 ######     #######   ##    ##   ########   
##    ##   ##     ##  ###   ##   ##         
##         ##     ##  ####  ##   ##         
##         ##     ##  ## ## ##   ######     
##         ##     ##  ##  ####   ##         
##    ##   ##     ##  ##   ###   ##         
 ######     #######   ##    ##   ##         
*/

/** 
	À décommenter et modifier pour activer un chargement entre les changements de page
	fonctions : showLoader / hideLoader à compléter
	Defaut : false
 **/
// pageTransition = true;

/** 
	À décommenter et modifier pour activer le chargement des pages en ajax
	Defaut : false
	Note : les liens qui font appel à un chargement via AJAX doivent contenir l'attribut rel="address"
 **/
// pageAjax = true;

/** 
	À décommenter et modifier pour changer le breakpoint activant les animations parallax
	activé par défaut à partir de
 */


(function ($) {

	/*
	########   ########    ######    ####  ########   ########   
	##     ##  ##         ##    ##    ##        ##    ##         
	##     ##  ##         ##          ##       ##     ##         
	########   ######      ######     ##      ##      ######     
	##   ##    ##               ##    ##     ##       ##         
	##    ##   ##         ##    ##    ##    ##        ##         
	##     ##  ########    ######    ####  ########   ########   
	
	##     ##     ###     ##    ##   ########   ##         ########   ########   
	##     ##    ## ##    ###   ##   ##     ##  ##         ##         ##     ##  
	##     ##   ##   ##   ####  ##   ##     ##  ##         ##         ##     ##  
	#########  ##     ##  ## ## ##   ##     ##  ##         ######     ########   
	##     ##  #########  ##  ####   ##     ##  ##         ##         ##   ##    
	##     ##  ##     ##  ##   ###   ##     ##  ##         ##         ##    ##   
	##     ##  ##     ##  ##    ##   ########   ########   ########   ##     ##  
	*/

	/* Fonctions exécutées à chaque resize */
	var resizeHandler = function () {
		$(window).trigger('scroll');
		initScrollAnimations();
		resizeParallax();

		/* Autres fonctions jouées au resize */
		// resizeSlider();
		// resizeNav();
	};


	/*
	 ######     ######    ########    #######   ##         ##         
	##    ##   ##    ##   ##     ##  ##     ##  ##         ##         
	##         ##         ##     ##  ##     ##  ##         ##         
	 ######    ##         ########   ##     ##  ##         ##         
		  ##   ##         ##   ##    ##     ##  ##         ##         
	##    ##   ##    ##   ##    ##   ##     ##  ##         ##         
	 ######     ######    ##     ##   #######   ########   ########   
	
	##     ##     ###     ##    ##   ########   ##         ########   ########   
	##     ##    ## ##    ###   ##   ##     ##  ##         ##         ##     ##  
	##     ##   ##   ##   ####  ##   ##     ##  ##         ##         ##     ##  
	#########  ##     ##  ## ## ##   ##     ##  ##         ######     ########   
	##     ##  #########  ##  ####   ##     ##  ##         ##         ##   ##    
	##     ##  ##     ##  ##   ###   ##     ##  ##         ##         ##    ##   
	##     ##  ##     ##  ##    ##   ########   ########   ########   ##     ##  
	*/
	/* Fonctions exécutées au scroll */
	var scrollHandler = function () {
		var scrollTop = $(window).scrollTop();


		if (scrollTop > 30) {
			$('.menu-bg').addClass('menu-bg-visible');
		} else {
			$('.menu-bg').removeClass('menu-bg-visible');
		}


	};


	/*
	##          #######      ###     ########   ########   ########   
	##         ##     ##    ## ##    ##     ##  ##         ##     ##  
	##         ##     ##   ##   ##   ##     ##  ##         ##     ##  
	##         ##     ##  ##     ##  ##     ##  ######     ########   
	##         ##     ##  #########  ##     ##  ##         ##   ##    
	##         ##     ##  ##     ##  ##     ##  ##         ##    ##   
	########    #######   ##     ##  ########   ########   ##     ##  
	*/

	showLoader = function (url) {
		tl = new TimelineLite();
		tl.pause();
		tl.add([
			// On peut chainer les évènements TweenMax ici. Example :
			// TweenMax.fromTo( $pan2l, 0,   { opacity: 0 }, { opacity: 1, delay: 0.10 } ),
			// TweenMax.fromTo( $pan3l, 0,   { opacity: 0 }, { opacity: 1, delay: 0.20 } ),
			// TweenMax.fromTo( $logo,  0.1, { opacity: 0 }, { opacity: 1, delay: 0.20 } )
		]);
		tl.call(function () {
			$(window).scrollTop(0);
			if (!pageAjax) {
				// A la fin de l'anim, on redirige vers la nouvelle URLs
				window.location.href = url;
			} else {
				// Exécution de la fonction qui va charger le nouveau contenu en ajax
				ajaxUrl.perform_ajax_request(url);
			}
		});
		tl.play();
	};

	var hideLoader = function () {
		// On lance l'animation de révélation de la page
		tl = new TimelineLite();
		tl.pause();
		tl.call(function () {
			initScrollAnimations();
		});
		tl.add([
			// On peut chainer les évènements TweenMax ici. Example :
			// TweenMax.fromTo( $pan1, 0.4, { x: '0' }, { x: '100%', delay: 0 } ),
			// TweenMax.fromTo( $pan2, 0.4, { x: '0' }, { x: '100%', delay: 0.15 } ),
			// TweenMax.fromTo( $logo, 0.2, { opacity: 1 }, { opacity: 0, delay: 0  } )
		], [], this, 1);
		tl.play();
	};

	/*	Ajout d'un loader sur le chargement initial d’une page 
		Uniquement si la fonction de transition de page est active 
	*/
	if (pageTransition) {
		$('body').imagesLoaded({background: true})
			.always(function (instance) {
				hideLoader();
			});
	}

	/*
 ######    ##         ####  ########   ########   ########
##    ##   ##          ##   ##     ##  ##         ##     ##
##         ##          ##   ##     ##  ##         ##     ##
 ######    ##          ##   ##     ##  ######     ########
	  ##   ##          ##   ##     ##  ##         ##   ##
##    ##   ##          ##   ##     ##  ##         ##    ##
 ######    ########   ####  ########   ########   ##     ##
*/

	var time = 80;
	var $bar,
		$slick,
		isPause,
		tick,
		percentTime;


	$bar = $('.progress');

	function startProgressbar() {
		resetProgressbar();
		percentTime = 0;
		isPause = false;
		tick = setInterval(interval, 10);
	}

	function interval() {
		if (isPause === false) {

			percentTime += 1 / (time + 0.1);
			$bar.css({
				width: (percentTime * 14.25) + "%"
			});

			if (percentTime >= 7) {
				$slick.slick('slickNext');
				// startProgressbar();
			}

		}
	}

	function resetProgressbar() {
		$bar.css({
			width: 0 + '%'
		});
		clearTimeout(tick);
	}

	$slick = $('.slick-slider-home, .slider--prog');
	$slick.on('init', function () {
		startProgressbar();
	}).on('init reInit beforeChange', function (event, slick, currentSlide, nextSlide) {
		var i = (nextSlide ? nextSlide : 0) + 1;
		$(".slider-num em").html("0" + i);
		startProgressbar();
	}).on('afterChange', function (event, slick, currentSlide, nextSlide) {
	}).slick({
		cssEase: 'ease-out',
		// autoplay: false,
		fade: true,
		nextArrow: $('.arrow-right, .arrow-right-banner'),
		prevArrow: $('.arrow-left, .arrow-left-banner')//,
		// asNavFor: '#slick-slider2'
	});

	if ($('.home #slick-slider2').length > 0) {

		$slick.slick("slickSetOption", "asNavFor", "#slick-slider2");

	}

	$('.home #slick-slider2').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		delay: 2000,
		speed: 2000,
		fade: true,
		draggable: false
	});

	// startProgressbar();

	$('.slick-slider-appartext').slick({
		nextArrow: $('.arrow-right-appartext'),
		prevArrow: $('.arrow-left-appartext'),
		fade: true
	});

	var $slickElement = $('.slick-slider-temoignage');

	$slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
	}).slick({
		infinite: true,
		autoplay: true,
		arrows: false,
		cssEase: 'ease-in-out',
		autoplaySpeed: 4500
	});

	if ( $('.slider-hc').length ) {


		$('.slider-hc').slick({
			infinite: true,
			autoplay: true,
			arrows: false,
			delay: 2000,
			speed: 800,
			fade: false,
			cssEase: 'ease-in-out',
			draggable: false
		});

		$('.arrows-hc .arrow-left').click(function (e) {
			$('.slider-hc').slick('slickPrev');
		});

		$('.arrows-hc .arrow-right').click(function (e) {
			$('.slider-hc').slick('slickNext');
		});

	}


	/*
	 ######    ########   ########   
	##    ##   ##         ##    ##   
	##         ##             ##     
	##         ######        ##      
	##         ##           ##       
	##    ##   ##           ##       
	 ######    ##           ##       
	*/

	var btn = $('button.wpcf7-submit');

	btn.on('click', function () {
		$(this).addClass('disabled');

		setTimeout(function () {
			$(this).removeClass('disabled');
		}, 1000);
	});

	$('.wpcf7').on('wpcf7mailsent', function () {
		if (window.location.href.indexOf('/programmes/caudalies') > 0) {
			var uniqueID = 'diago' + new Date().getTime();
			$('body').append('<img src="http://tbl.tradedoubler.com/report?organization=2215812&event=391527&orderNumber=' + uniqueID + '" width="1" height="1" border="0" >');
		}
	});


	$('.form_acceptance input[type="checkbox"], .form_acceptance label').on('click', function (e) {

		var checkbox = $(this).closest('form').find('.form_acceptance input[type="checkbox"]');
		var current_btn = $(this).closest('form').find('button ');

		if (checkbox.prop('checked') == true) {
			current_btn.removeClass('disabled');

		} else {
			current_btn.addClass('disabled');
		}
	});

	btn.on('click', function () {
		btn.addClass('disabled');

		setTimeout(function () {
			btn.removeClass('disabled');
		}, 500);
	});

	function getFormDataValidity() {
		var setUserLastTimestamp = localStorage.getItem('current_userTimestamp');
		// var setUserLastTimestamp = 1575452254000;

		if (setUserLastTimestamp == null) {

			return false;

		} else {

			var timeDiff;
			var currentTimestamp = new Date().getTime();
			timeDiff = ((((currentTimestamp - setUserLastTimestamp) / 1000) / 60) / 60);

			// Si supérieur à 12h, le formulaire sera à nouveau affiché et les
			// données en localStorage effacées
			if (timeDiff > 12) {
				localStorage.removeItem("current_userTimestamp");
				localStorage.removeItem("current_surname");
				localStorage.removeItem("current_firstname");
				localStorage.removeItem("current_email");
				localStorage.removeItem("current_phone");
				return false;
			} else {
				return true;
			}
		}
	}

	function nextDownload(fileURL, fileName) {
		var sendTo = $('.content-prog').data('send-to');
		var appart = $('.content-prog').data('appart-title');
		var prog = $('.content-prog').data('prog-name');
		var surname = localStorage.getItem("current_surname");
		var firstname = localStorage.getItem("current_firstname");
		var email = localStorage.getItem("current_email");
		var phone = localStorage.getItem("current_phone");

		$.post(
			mcubeArgs.ajaxurl,
			{
				action: 'sendDownloadNotification',
				diag_sendto: sendTo,
				diag_file: fileName,
				diag_appart: appart,
				diag_prog: prog,
				diag_surname: surname,
				diag_firstname: firstname,
				diag_email: email,
				diag_phone: phone
			}
		);

		var win = window.open(fileURL, '_blank');
		win.focus();
	}

	function initBtnFileDownload() {
		$('.file-link').each(function (index, elem) {
			var $trigger = $(elem).find('.popup-modal');
			var $target = $(elem).find('.file-download__form');
			var $targetModal = $(elem).find('.block-form--modal');
			var $form = $(elem).find('.wpcf7');
			var popupID = "#" + $target.attr('id');

			var sendTo = $trigger.data('send-to');
			var fileName = $trigger.data('file-name');
			var fileURL = $trigger.data('file-url');
			var appartName = $trigger.data('appart-name');
			var progName = $trigger.data('prog-name');

			$trigger.on('click', function () {

				// S’il y a des données valides pour l’utilisateur dans localStorage :
				// Pas de popup + envoi des données par email en sous marin
				// ouverture du fichier demandé par l'utilisateur
				if (getFormDataValidity()) {

					nextDownload(fileURL, fileName);

					// Si les données sont null ou obsolètes (supérieures à 12h)
					// on demande à l’internaute de saisir ses infos pour
					// lancer le téléchargement.
				} else {
					var that = $(this);

					$target.find('input[name="send_to"]').val(sendTo);
					$target.find('input[name="file_name"]').val(fileName);
					$target.find('input[name="appart_name"]').val(appartName);
					$target.find('input[name="prog_name"]').val(progName);

					$(this).magnificPopup({
						src: popupID,
						type: 'inline',
						preloader: false,
						focus: '#surname',
						modal: true
					}).magnificPopup('open');

					$(document).on('click', '.popup-modal-dismiss', function (e) {
						e.preventDefault();
						$.magnificPopup.close();
					});

					$target.find('.wpcf7-submit').click(function (e) {
						$targetModal.addClass('block-form--event-blocked');
					});

					$form.on('mailfailed.wpcf7 invalid.wpcf7 spam.wpcf7 mailsent.wpcf7', function () {
						$targetModal.removeClass('block-form--event-blocked');
					});

					$form.on('mailfailed.wpcf7', function () {
						$targetModal.addClass('failed');
					});

					$form.on('mailsent.wpcf7', function (e) {
						var currentSurname = $target.find('input[name="surname"]').val();
						var currentFirstname = $target.find('input[name="firstname"]').val();
						var currentPhone = $target.find('input[name="phone"]').val();
						var currentEmail = $target.find('input[name="email"]').val();

						$resetForm = $targetModal.find('#resetForm');

						localStorage.setItem('current_userTimestamp', new Date().getTime());
						localStorage.setItem('current_surname', currentSurname);
						localStorage.setItem('current_firstname', currentFirstname);
						localStorage.setItem('current_phone', currentPhone);
						localStorage.setItem('current_email', currentEmail);

						setTimeout(function () {
							that.off('click.magnificPopup');
							var win = window.open(fileURL, '_blank');
							$targetModal.removeClass('success');
							$.magnificPopup.close();
							$resetForm.click();

							win.focus();

						}, 100);
					});
				}
			});
		});
	}


	/*
	########   ########   ########   ########    ######    ########    ######    
	##         ##         ##         ##         ##    ##      ##      ##    ##   
	##         ##         ##         ##         ##            ##      ##         
	######     ######     ######     ######     ##            ##       ######    
	##         ##         ##         ##         ##            ##            ##   
	##         ##         ##         ##         ##    ##      ##      ##    ##   
	########   ##         ##         ########    ######       ##       ######    
	*/

	$('.btn-menu-mobile-open').on('click', function () {

			$('body').addClass('noscroll');
			$('.nav-main').addClass('nav-main--opened');
			$('li').addClass('li-visible');
			$('.bg2-menu-mobile').addClass('bg2-menu-mobile--opened');
		}
	);

	$('.btn-menu-mobile-close, .bg2-menu-mobile').on('click', function () {
			$('body').removeClass('noscroll');
			$('.nav-main').removeClass('nav-main--opened');
			$('.bg2-menu-mobile').removeClass('bg2-menu-mobile--opened');
			$('li').removeClass('li-visible');
		}
	);

	$('.onglet-form-contact-right').on('click', function () {
			$('.onglet-form-contact-left').addClass('onglet-form-contact--not-selected');
			$('.onglet-form-contact-right').removeClass('onglet-form-contact--not-selected');
			$('.form-contact-terrain').removeClass('hidden');
			$('.form-contact-info').addClass('hidden');
		}
	);

	$('.onglet-form-contact-left').on('click', function () {
			$('.onglet-form-contact-right').addClass('onglet-form-contact--not-selected');
			$('.onglet-form-contact-left').removeClass('onglet-form-contact--not-selected');
			$('.form-contact-info').removeClass('hidden');
			$('.form-contact-terrain').addClass('hidden');
		}
	);


	$(document).ready(function () {

		var window_width = jQuery(window).width();

		if (window_width < 991) {
			jQuery("#sticky-subnav").trigger("sticky_kit:detach");
		} else {
			make_sticky();
		}

		jQuery(window).resize(function () {

			window_width = jQuery(window).width();

			if (window_width < 991) {
				jQuery("#sticky-subnav").trigger("sticky_kit:detach");
			} else {
				make_sticky();
			}

		});

		function make_sticky() {
			$("#sticky-subnav").sticky({topSpacing: 18});
		}

		$('.gallery').each(function () { // the containers for all your galleries
			$(this).magnificPopup({
				delegate: 'a', // the selector for gallery item
				type: 'image',
				image: {
					titleSrc: function (item) {
						return item.el.closest('.gallery-item').find('.gallery-caption').html();
					}
				},
				gallery: {
					enabled: true,
					tCounter: '<span></span>'
				}
			});
		});


		// $('.gallery:not(#gallery-1)').magnificPopup({
		// 	delegate: 'a',
		// 	type:'image',
		// 	gallery:{
		// 		enabled: true,
		// 		tCounter: '<span class="mfp-counter">%curr% sur %total%</span>'
		// 	}
		// });

		// $('#gallery-1').magnificPopup({
		// 	delegate: 'a',
		// 	type:'image',
		// 	gallery:{
		// 		enabled: false,
		// 		tCounter: false

		// 	}
		// });

		$('.gallery a').addClass('no-link');

		if (window.location.hash) {

			if ($('.sous-menu-prog').length > 0) {
				var top = parseInt($('.sous-menu-prog').offset().top) - parseInt($('.header .menu-bg').height());
				$('html, body').animate({scrollTop: top}, 740);
			}

		} else {

		}
	});

	/*
	####  ##    ##   ####  ########   
	 ##   ###   ##    ##      ##      
	 ##   ####  ##    ##      ##      
	 ##   ## ## ##    ##      ##      
	 ##   ##  ####    ##      ##      
	 ##   ##   ###    ##      ##      
	####  ##    ##   ####     ##      
	*/

	// Charge la function permettant de gérer le chargement des pages via AJAX
	if (pageAjax) {
		ajaxUrl.init();
	}

	var pageInit = function () {

		var controller = new ScrollMagic.Controller();

		// Déclaration des évènements
		$(window).on('resize orientationchange', addEndEvent);
		$(window).on('resizeEnd', resizeHandler);
		$(window).on('scroll', scrollHandler);
		$('body').on('reveal', '.sr', scrollRevealHandler);

		$(window).trigger('resize'); // Joue la fonction resizeHandler()
		formLoader();                // Affiche un 'cache' à la validation d’un form CF7
		initBtnFileDownload();

		function initAlerts() {
			if ( $( '#alert_modal' ).length && ( $.cookie( 'alert' ) != "shown" ) )  {
				$.magnificPopup.open({
					items: { src: '#alert_modal' },
					type: 'inline',

				}, 0);

				$.cookie('alert', 'shown', {
					expires: 1, path: '/'
				});
			}
		}
		initAlerts();

		/* Autres scripts qui doivent être initialisés */
		// slider.init();
		$('.data-mh').matchHeight();

		// Local smooth scroll sur les liens vers des ancres
		if ($('.localscroll').length > 0) {
			$('.localscroll').localScroll({
				hash: true
			});
			$.localScroll.hash();
		}

		// Fitvids = video embed responsive
		if ($('.fitvids').length > 0) {
			$('.fitvids').fitVids();
		}

		// Transmission des liens vers la fonction linkHandler()
		$('[data-link]').click(function (e) {
			linkHandler($(this));
		}).find('a').click(function (e) {
			e.stopPropagation();
		});

		$('a').click(function (e) {
			e.preventDefault();
			linkHandler($(this));
		});

		// Charge la function permettant de gérer le chargement des pages via AJAX
		if (pageAjax) {
			ajaxUrl();
		}

		// Exemple d'utilisation du plugin Mcube Gmaps
		if ($('.map').length > 0) {
			$('.map').mcubeGmaps({
				bounds: false, // default : true
				overlay: false // default : true
			});
		}

		$(".js-valid-search").click(function (e) {
			e.preventDefault();
			$(".search-bar").submit();
		});

		$(".gallery-hc").on('click', function () {
			$(this).find('a').magnificPopup({
				type: 'image',
				gallery: {
					enabled: true,
				}
			}).magnificPopup('open');
		});
		var tween;
		if (window.innerWidth > 990) {

			//Form qui suit le secroll
			tween = new TweenMax.to($(".form-contact-landing-hc-container"), 1, {
				y: $('.form-contact-landing-hc-container').height(),
				ease: Linear.easeNone
			});
			var formScrollScene = new ScrollMagic.Scene(
				{
					triggerElement: ".page",
					duration: $(".form-contact-landing-hc-container").height(),
					offset: (window.innerHeight / 2) + 320
				})
				.setTween(tween)
				.addTo(controller);

			$(window).on('resize', function () {
				formScrollScene.offset((window.innerHeight / 2) + 320);
				formScrollScene.duration($(".form-contact-landing-hc-container").height());
			});
		}

		if (window.innerWidth > 1200) {
			// Galerie
			var galerieWidth = 0;
			$('.galerie-image').each(function (index, elem) {
				galerieWidth += $(this).outerWidth(true);
			});
			$('.galerie').width(galerieWidth);

			tween = new TweenMax.to($('.galerie'), 1, {
				x: -(galerieWidth - $('.container').width()),
				ease: Linear.easeNone
			});

			new ScrollMagic.Scene({
				triggerElement: '.galerie',
				triggerHook: "onLeave",
				duration: galerieWidth,
				offset: -120
			})
				.setTween(tween)
				.setPin('.galerie')
				.addTo(controller);
		}
	};

	// Functions à réinitialisées après un chargement de page via ajax
	afterAjax = function () {
		$('.data-mh').matchHeight();
		resizeParallax();
	};

	// Initialisation de toutes les fonctions utiles au chargement de la page
	pageInit();

})(jQuery);
